export default {"src":"/_next/static/media/secure.6835442f.svg","height":114,"width":151,"blurWidth":0,"blurHeight":0};